import { render, staticRenderFns } from "./payroll-detail.vue?vue&type=template&id=4a36cb36&scoped=true&"
import script from "./payroll-detail.vue?vue&type=script&lang=js&"
export * from "./payroll-detail.vue?vue&type=script&lang=js&"
import style0 from "./payroll-detail.vue?vue&type=style&index=0&id=4a36cb36&scoped=true&lang=css&"
import style1 from "./payroll-detail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a36cb36",
  null
  
)

export default component.exports